<div id="escorteds">
  <ng-container *ngIf="days; else day_single">
    <ng-container *ngFor="let day of days; let index = index">
      <ng-container *ngFor="let optional of day.escorteds[0]?.optionals">
        <div class="container" *ngIf="optional.type"
          [id]="optional?.code ? 'svc-' + optional.code : null">
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <img class="img-fluid service-photo" [src]="optional.image" [alt]="optional.title"
                [fallbackSrc]="defaultImage || noImageUrl"
                [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
            </div>
            <div class="col-xs-12 col-md-8 itinerary-content itinerary-title--custom">
              <h6>
                <span class="text-capitalize">{{ optional.type }}</span>
              </h6>
              <app-pnr [pnr]="optional.pnr" [supplierName]="optional.supplierName"></app-pnr>
              <div class="itinerary-content" *ngIf="optional.items && optional.items[0]?.name">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-bed"></em></span>
                  <h6>
                    <span class="text-capitalize">{{ optional.items[0].name }}</span>
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="((optional.items[0]?.adults?.totalNumber || 0) + (optional.items[0]?.children?.totalNumber || 0)) || totalPax">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                  <h6>
                    <span>{{ (optional.items[0]?.adults?.totalNumber || 0) + (optional.items[0]?.children?.totalNumber || 0) || totalPax }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                  </h6>
                </div>
              </div>
              <ng-container *ngIf="optional.description">
                <span [innerHTML]="optional.description | safeHtml" class="text-muted small"></span>
              </ng-container>
              <ng-container *ngFor="let d of optional.descriptions">
                <ng-container *ngIf="d.code === 'ServiziInclusi'">
                  <span [innerHTML]="d.value | safeHtml" class="text-muted small"></span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="container mt-3" *ngFor="let step of optional?.steps">
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <img class="img-fluid service-photo" [src]="step.photo" [alt]="step.title" [fallbackSrc]="defaultImage || noImageUrl"
                [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
            </div>
            <div class="col-xs-12 col-md-8">
              <div class="itinerary-content itinerary-title--custom"> <!-- *ngIf="step.title" -->
                <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon></span>
                <h6>
                  <span class="text-capitalize">{{ optional.type }}</span>
                </h6>
              </div>
              <div class="itinerary-content" *ngIf="step.cityName">
                <div class="itinerary-adress">
                  <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
                  <h6>
                    <span class="text-capitalize">{{ step.cityName }}</span>
                    <!-- <span *ngIf="step.cityCode"> ({{ step.cityCode }})</span> -->
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="step.dateFrom || step.dateTo">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-calendar-alt"></em></span>
                  <h6>
                    <span *ngIf="step.dateFrom">{{ step.dateFrom | localizedDate: "dd MMM" }}</span>
                    <span *ngIf="step.dateFrom && step.dateTo"> - </span>
                    <span *ngIf="step.dateTo">{{ step.dateTo | localizedDate: "dd MMM" }}</span>
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="step.nights">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-moon"></em></span>
                  <h6>
                    <span>{{ step.nights }} {{ (step.nights == 1 ? 'ITINERARY.NIGHT' : 'ITINERARY.NIGHTS') | translate
                      }}</span>
                  </h6>
                </div>
              </div>
              <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && step.dateFrom === day.date && day?.escorteds[0]?.notes">
                <ng-container *ngFor="let item of day?.escorteds[0]?.notes">
                  <ng-container *ngIf="state === 'Preventivo'">
                    <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                      <span [innerHTML]="item.text | safeHtml"></span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="state === 'Confermata'">
                    <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                      <span [innerHTML]="item.text | safeHtml"></span>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </p>
              <ng-container *ngIf="replaceShowDescriptionButtonWithNotes; else escortedStepDescriptionToggle">
                <ng-container *ngFor="let description of step.descriptions">
                  <span [innerHTML]="description.text | safeHtml" class="text-muted small"></span>
                </ng-container>
                <details class="details details-optional"
                  *ngIf="step.dateFrom === day.date && getFilteredNotes(day?.escorteds[0]?.notes).length > 0">
                  <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                    attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
                  </summary>
                  <div class="row">
                    <div class="col-12">
                      <ng-container *ngFor="let item of getFilteredNotes(day?.escorteds[0]?.notes)">
                        <span [innerHTML]="item.text | safeHtml"></span>
                      </ng-container>
                    </div>
                  </div>
                </details>
              </ng-container>
              <ng-template #escortedStepDescriptionToggle>
              <ng-container *ngIf="step.descriptions && step.descriptions.length > 0">
                <details class="details details-optional" open>
                  <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                    attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
                  </summary>
                  <div class="row">
                    <div class="col-12">
                      <ng-container *ngFor="let description of step.descriptions">
                        <span [innerHTML]="description.text | safeHtml" class="text-muted small"></span>
                      </ng-container>
                    </div>
                  </div>
                </details>
              </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #day_single>
    <ng-container *ngFor="let escorted of day.escorteds">
      <ng-container *ngFor="let optional of escorted?.optionals">
        <div class="container" *ngIf="optional.type && day.date === optional.date"
          [id]="optional?.code ? 'svc-' + optional.code : null">
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <img class="img-fluid service-photo" [src]="optional.image" [alt]="optional.title"
                [fallbackSrc]="defaultImage || noImageUrl"
                [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
            </div>
            <div class="col-xs-12 col-md-8 itinerary-content itinerary-title--custom">
              <h6>
                <span class="text-capitalize">{{ optional.type }}</span>
              </h6>
              <app-pnr [pnr]="optional.pnr" [supplierName]="optional.supplierName"></app-pnr>
              <div class="itinerary-content" *ngIf="optional.items && optional.items[0]?.name">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-bed"></em></span>
                  <h6>
                    <span class="text-capitalize">{{ optional.items[0].name }}</span>
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="((optional.items[0]?.adults?.totalNumber || 0) + (optional.items[0]?.children?.totalNumber || 0)) || totalPax">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                  <h6>
                    <span>{{ (optional.items[0]?.adults?.totalNumber || 0) + (optional.items[0]?.children?.totalNumber || 0) || totalPax }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                  </h6>
                </div>
              </div>
              <ng-container *ngIf="optional.description">
                <span [innerHTML]="optional.description | safeHtml" class="text-muted small"></span>
              </ng-container>
              <ng-container *ngFor="let d of optional.descriptions">
                <ng-container *ngIf="d.code === 'ServiziInclusi'">
                  <span [innerHTML]="d.value | safeHtml" class="text-muted small"></span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="container mt-3" *ngFor="let step of optional?.steps">
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <img class="img-fluid service-photo" [src]="step.photo" [alt]="step.title" [fallbackSrc]="defaultImage || noImageUrl"
                [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
            </div>
            <div class="col-xs-12 col-md-8">
              <div class="itinerary-content itinerary-title--custom"> <!-- *ngIf="step.title" -->
                <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon></span>
                <h6>
                  <span class="text-capitalize">{{ optional.type }}</span>
                </h6>
              </div>
              <div class="itinerary-content" *ngIf="step.cityName">
                <div class="itinerary-adress">
                  <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
                  <h6>
                    <span class="text-capitalize">{{ step.cityName }}</span>
                    <!-- <span *ngIf="step.cityCode"> ({{ step.cityCode }})</span> -->
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="step.dateFrom || step.dateTo">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-calendar-alt"></em></span>
                  <h6>
                    <span *ngIf="step.dateFrom">{{ step.dateFrom | localizedDate: "dd MMM" }}</span>
                    <span *ngIf="step.dateFrom && step.dateTo"> - </span>
                    <span *ngIf="step.dateTo">{{ step.dateTo | localizedDate: "dd MMM" }}</span>
                  </h6>
                </div>
              </div>
              <div class="itinerary-content" *ngIf="step.nights">
                <div class="itinerary-night">
                  <span class="itinerary-icons"><em class="fas fa-moon"></em></span>
                  <h6>
                    <span>{{ step.nights }} {{ (step.nights == 1 ? 'ITINERARY.NIGHT' : 'ITINERARY.NIGHTS') | translate
                      }}</span>
                  </h6>
                </div>
              </div>
              <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && step.dateFrom === optional.date && day?.escorteds[0]?.notes">
                <ng-container *ngFor="let item of day?.escorteds[0]?.notes">
                  <ng-container *ngIf="state === 'Preventivo'">
                    <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                      <span [innerHTML]="item.text | safeHtml"></span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="state === 'Confermata'">
                    <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                      <span [innerHTML]="item.text | safeHtml"></span>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </p>
              <ng-container *ngIf="replaceShowDescriptionButtonWithNotes; else singleEscortedStepDescriptionToggle">
                <ng-container *ngFor="let description of step.descriptions">
                  <span [innerHTML]="description.text | safeHtml" class="text-muted small"></span>
                </ng-container>
                <details class="details details-optional"
                  *ngIf="step.dateFrom === optional.date && getFilteredNotes(day?.escorteds[0]?.notes).length > 0">
                  <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                    attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
                  </summary>
                  <div class="row">
                    <div class="col-12">
                      <ng-container *ngFor="let item of getFilteredNotes(day?.escorteds[0]?.notes)">
                        <span [innerHTML]="item.text | safeHtml"></span>
                      </ng-container>
                    </div>
                  </div>
                </details>
              </ng-container>
              <ng-template #singleEscortedStepDescriptionToggle>
              <ng-container *ngIf="step.descriptions && step.descriptions.length > 0">
                <details class="details details-optional" open>
                  <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                    attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
                  </summary>
                  <div class="row">
                    <div class="col-12">
                      <ng-container *ngFor="let description of step.descriptions">
                        <span [innerHTML]="description.text | safeHtml" class="text-muted small"></span>
                      </ng-container>
                    </div>
                  </div>
                </details>
              </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</div>